<template>
  <div class="message">
    <div class="message-wrap">
      <h1 class="personal-center-form__title">消息</h1>
      <div class="container">
        <div>
          <el-table :data="content"
                    style="width: 100%"
                    @row-dblclick="toMsgdeatils"
                    >
            <el-table-column 
                            
                             label="发送人"
                             align="center"
                             min-width="20">
              <template slot-scope="scope">
                <span class="tip">系统信息<i :class="scope.row.state == '未读' ? 'red-point' : ''"></i></span>
              </template>

            </el-table-column>

            <el-table-column prop="content"
                             label="信息"
                             align="center"
                             min-width="60">
            </el-table-column>
            <el-table-column prop="sendTime"
                             label="时间"
                             align="center"
                             min-width="30">
            </el-table-column>

            <el-table-column label="操作"
                             align="center"
                             min-width="20">
                <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)"  type="text" size="small">查看</el-button>
        <el-button @click="pup(scope.row)" type="text" size="small">删除</el-button>
      </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="content.length > 1" class="block">
          <el-pagination layout="prev, pager, next"
          @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
     
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import messageApi from '../../api/message';
import confirmModal from '../common/Confirm.vue';
export default {
  methods: {
    toMsgdeatils (row, column, index) {
      if (row.state == '未读') {
        const msgNum = this.$store.state[1].msgNum - 1;
        this.$store.commit('changeState', msgNum);
      } else {
        const msgNum = this.$store.state[1].msgNum;
        this.$store.commit('changeState', msgNum);
      }
      this.$router.push({ path: '/personalCenter/messagedetails',
        query: {
          msgRemindId: row.msgRemindId
        } });
    },
    handleClick (row) {
      if (row.state == '未读') {
        const msgNum = this.$store.state[1].msgNum - 1;
        this.$store.commit('changeState', msgNum);
      } else {
        const msgNum = this.$store.state[1].msgNum;
        this.$store.commit('changeState', msgNum);
      }
      this.$router.push({ path: '/personalCenter/messagedetails',
        query: {
          msgRemindId: row.msgRemindId
        } });
    },
    pup (row) {
      this.$confirm('此操作将永久删除该消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteClick(row);
      }).catch(() => {
      });
    },
    deleteClick (row) {
      messageApi.deletMsg({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        msgRemindId: row.msgRemindId
      }).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          if (row.state == '未读') {
            const msgNum = this.$store.state[1].msgNum - 1;
            this.$store.commit('changeState', msgNum);
          } else {
            const msgNum = this.$store.state[1].msgNum;
            this.$store.commit('changeState', msgNum);
          }
          this.fetchData();
          // setTimeout(() => {
          //   window.location.reload();
          // }, 500);
        } else {
          this.$message.error('删除失败');
        }
      }).catch((err) => {
        this.$message.error('删除失败');
        console.log('err', err);
      });
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.pageNum = val;
      this.pageSize = val;
      this.fetchData();
    },
    fetchData () {
      messageApi.msgRemindList({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        pageNum: this.pageNum,
        pageSize: 10
      }).then((res) => {
        if (res.code === 0) {
          this.content = res.result.content;
          this.totalCount = parseFloat(res.result.totalElements);
        } else {

        }
      }).catch((err) => {
        console.log('err', err);
      });
    },
    ...mapActions({
      getLoanAllData: types.GET_LOAN_ALL_DATA,
      signAture: types.SIGN_AGREEMENT,
      downContract: types.DOWN_AGREEMENT,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    ...mapMutations({
      setLoanAllData: types.SET_LOAN_ALL_DATA,
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
      setSigned: types.SET_SIGNED
    })
  },
  data () {
    return {
      totalCount: 0,
      currentPage: 1,
      content: [],
      bankList: []
    };
  },
  components: {
    confirmModal
  },
  created () {
    this.fetchData();
  },
  computed: {
    ...mapGetters({})
  },
  mounted () {

  }
};
</script>
<style lang="scss">
.message {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 15px;
  padding-left: 30px;
  .container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 20px;
    padding-bottom: 75px;
    background-color: #fff;
  }
}
.tip {
  position: relative;
  .red-point {
    display: block;
    background: #f00;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    top: 5px;
    left: -20px;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// message.vue?8f5d22b6